// Админ › Ниши — the list, and the editor for whichever row is open.

import { useState } from 'react';
import { useVerticals } from './useVerticals.js';
import { VerticalEditor } from './VerticalEditor.js';
import { VerticalsList } from './VerticalsList.js';

export function VerticalsSection() {
  const { data: verticals = [], isLoading, error } = useVerticals();
  const [openKey, setOpenKey] = useState<string | null>(null);
  const open = verticals.find((v) => v.key === openKey) ?? null;

  if (isLoading) return <p className="adm__msg">Зареждане на нишите…</p>;
  if (error) return <p className="adm__err">{(error as Error).message}</p>;

  if (open !== null) {
    return <VerticalEditor key={open.key} vertical={open} onClose={() => setOpenKey(null)} />;
  }
  return <VerticalsList verticals={verticals} onOpen={setOpenKey} />;
}
